import api from "./api";
import { API_MOBILE_PROVIDERS } from "../constants/urls";


export const provider = {
    getAll: async () => (await api.get(API_MOBILE_PROVIDERS)).data,
    getById: async (id) => (await api.get(`${API_MOBILE_PROVIDERS}/${id}`)).data,
    create: async (provider) => (await api.post(API_MOBILE_PROVIDERS, provider)).data,
    update: async (provider) => (await api.put(`${API_MOBILE_PROVIDERS}/${provider.id}`, provider)).data,
    delete: async (id) => (await api.delete(`${API_MOBILE_PROVIDERS}/${id}`)).data,
};
